import { z } from 'zod';

export const UserTrainingSchema = z.object({
    id: z.string().optional(),
    userId: z.string().min(1),
    trainingId: z.string().min(1),
    status: z.string().default('assigned'), // assigned, in-progress, completed
    enrollmentDate: z.string().or(z.date()).optional(),
    completionDate: z.string().or(z.date()).optional(),
    score: z.number().optional(),
    certificateUrl: z.string().optional(),
    isArchived: z.boolean().optional().default(false),
    createdAt: z.date().optional(),
    updatedAt: z.date().optional(),
    customFields: z.record(z.unknown()).optional(),
    evaluationAttempts: z.array(z.object({
        attemptNumber: z.number().int().positive(),
        kind: z.enum(['initial', 'survey_retake', 'full_restart']).optional(),
        closedAt: z.union([z.string(), z.date()]).optional(),
        closedBy: z.string().optional(),
        notes: z.string().optional(),
        finalScore: z.number().optional(),
        maxScore: z.number().optional(),
        passed: z.boolean().optional(),
        reviewStatus: z.string().optional(),
        surveyScores: z.array(z.unknown()).optional(),
        watchWasReset: z.boolean().optional(),
    })).optional(),
});

export const RemediateEvaluationSchema = z.object({
    mode: z.enum(['survey_retake', 'full_restart']),
    notes: z.string().max(2000).optional(),
});
export const CreateUserTrainingSchema = UserTrainingSchema.omit({ id: true, createdAt: true, updatedAt: true });
export const UpdateUserTrainingSchema = UserTrainingSchema.partial();
